/* ============================================================
   I LIBRI CURIOSI · la home del marchio (31/10/2026)
   Caricato solo da sections/libricuriosi-home.liquid, con defer.
   Qui solo i pezzi della home: lo scorrimento morbido di "SCOPRI I NOSTRI
   LIBRI" fino ai libri. Carrello e "Aggiungi al carrello" degli ebook li
   gestisce libricuriosi.js (data-lc-aggiungi), come nel resto del sito.
   Sopra i 990 px Horizon fa scorrere .page-wrapper e non la finestra:
   scrollIntoView muove il contenitore giusto da solo.
   ============================================================ */
(() => {
  const home = document.querySelector('.lc-hm');
  if (!home) return;
  const fermo = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  home.querySelectorAll('[data-lc-hm-vai]').forEach(a => a.addEventListener('click', e => {
    const id = (a.getAttribute('href') || '').split('#')[1];
    const meta = id ? document.getElementById(id) : null;
    if (!meta) return;
    e.preventDefault();
    meta.scrollIntoView({ behavior: fermo ? 'auto' : 'smooth', block: 'start' });
    try { history.replaceState(null, '', '#' + id); } catch (err) {}
  }));

  /* recensioni: sul computer scorrono di lato, tre alla volta, con le frecce della scheda (lc-frecce,
     che libricuriosi.css mostra solo sopra i 900 px). Sul telefono si scorrono col dito come sempre. */
  const lista = home.querySelector('#recensioni .lc-rec-lista');
  const testa = home.querySelector('#recensioni .lc-sez-testa');
  if (lista && testa && lista.children.length > 3) {
    const f = document.createElement('div');
    f.className = 'lc-frecce lc-hm-frecce';
    f.innerHTML = '<button type="button" data-lc-hm-d="-1" aria-label="Recensioni precedenti"><svg class="lc-ico"><use href="#lc-i-sx"/></svg></button>' +
      '<button type="button" data-lc-hm-d="1" aria-label="Recensioni successive"><svg class="lc-ico"><use href="#lc-i-dx"/></svg></button>';
    testa.appendChild(f);
    const [prima, dopo] = f.querySelectorAll('button');
    const aggiorna = () => {
      prima.disabled = lista.scrollLeft < 4;
      dopo.disabled = lista.scrollLeft + lista.clientWidth > lista.scrollWidth - 4;
    };
    f.addEventListener('click', e => {
      const b = e.target.closest('[data-lc-hm-d]');
      if (!b) return;
      lista.scrollBy({ left: +b.dataset.lcHmD * lista.clientWidth, behavior: fermo ? 'auto' : 'smooth' });
    });
    lista.addEventListener('scroll', aggiorna, { passive: true });
    window.addEventListener('resize', aggiorna);
    aggiorna();
  }
})();
